// extracted by mini-css-extract-plugin
module.exports = {"currency-symbol":"CurrencyInput_currency-symbol__21oKj","currency-input":"CurrencyInput_currency-input__GQdAw"};